
import {namespace} from "vuex-class";
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import preferencesService from "@/services/preferences.service";

const userModule = namespace("userModule");

@Component({
    components: {}
})
export default class FieldIdentifierQualite extends Vue {

    @Prop() readonly items;
    @Prop() readonly identifiers;
    @Prop() readonly fileId;

    @userModule.State
    public user: any;

    headersSelectId = [];

    idFieldsFileType = [
        {
            text: "",
            value: "",
        },
        {
            text: "Raison sociale *",
            value: "raison_sociale",
        },
        {
            text: "Adresse",
            value: "adresse",
        },
        {
            text: "Ville",
            value: "ville",
        },
        {
            text: "Code postal",
            value: "code_postal",
        },
        {
            text: "Forme juridique",
            value: "formeJuridique",
        },
        {
            text: "Code NAF",
            value: "codeNaf",
        },
        {
            text: "Enseigne",
            value: "enseigne",
        },
        {
            text: "Siren",
            value: "siren",
        },
        {
            text: "Siret",
            value: "siret",
        }];
    idFieldsFile = [];
    idFieldTypeFileInput = [];


    @Watch('items', {deep: true, immediate: true})
    refresh(items) {
        this.idFieldTypeFileInput = [];
        this.headersSelectId = [];

        if (items && items.length > 0) {
            const length = Object.keys(items[0]).length - 2;
            for (let index = 0; index < length; index++) {
                this.headersSelectId.push({
                    text: index + "",
                    value: index + ""
                });
                this.idFieldsFile[index] = this.idFieldsFileType;
            }
        }
        if (this.identifiers) {
            this.idFieldTypeFileInput = this.identifiers;
        }
        this.changeType();
    }

    changeType() {
        for (let index = 0; index < this.idFieldsFile.length; index++) {
            const cpy = [...this.idFieldsFileType];
            this.idFieldsFile[index] = cpy.filter(item => {
                if (item.value == '') {
                    return true;
                }
                if (this.idFieldTypeFileInput[index]
                    && this.idFieldsFile[index].some(el => el.value === this.idFieldTypeFileInput[index]
                        && this.idFieldTypeFileInput[index] == item.value)) {
                    return true;
                }
                for (const iterator of this.idFieldTypeFileInput) {
                    if (item.value === iterator) {
                        return false;
                    }
                }
                return true;
            })
        }
    }

    savePreferenceIdFile() {
        const identifier = this.idFieldTypeFileInput;
        preferencesService
            .updateFileRepellerIdentifier(
                this.items[0].fileId,
                identifier,
                this.user.id
            ).then(() => {
            this.$emit('close', identifier);
        });
    }

    previewCss(value) {
      const words = value.split(' ');
      const longest = words.reduce((a, b) => a.length > b.length ? a : b);
      if (longest.length > 15 || value.length > 25) {
        return 'big-preview-header';
      } else if (longest.length > 10 || value.length > 15) {
        return 'medium-preview-header';
      } else {
        return 'preview-header';
      }
    }
}
